import type {
  PreparePaalaegIndberetningRequest,
  PreparePaalaegIndberetningResponse,
} from "@/interfaces/paalaegIndberetning";
import type { PendingEvidenceResponse } from "@/interfaces/indberetning";
import type { ReportEvidenceModel } from "@cle/models/reportEvidence";
import { ApiRequestError, getWithErrorObject, post } from "./util";

const PAALAEG_INDBERETNING_QUERY = "Paalaeg/indberetning";

export const PAALAEG_INDBERETNING_QUERY_KEY = [
  "paalaeg",
  "indberetning",
] as const;

export const createPaalaegEvidenceQueryKey = (paalaegId: string) =>
  [
    ...PAALAEG_INDBERETNING_QUERY_KEY,
    "paalaeg",
    paalaegId,
    "evidence",
  ] as const;

export const createPaalaegPendingEvidenceQueryKey = (indberetningId: string) =>
  [
    ...PAALAEG_INDBERETNING_QUERY_KEY,
    "pending-evidence",
    indberetningId,
  ] as const;

export const getPendingPaalaegIndberetningEvidence = async (
  indberetningId: string,
): Promise<PendingEvidenceResponse> => {
  try {
    return await getWithErrorObject<PendingEvidenceResponse>({
      query: `${PAALAEG_INDBERETNING_QUERY}/${indberetningId}/pending-evidence`,
    });
  } catch (error) {
    if (error instanceof ApiRequestError && error.status === 404) {
      return { evidenceItemIds: [] };
    }

    throw error;
  }
};

export const preparePaalaegIndberetningForSigning = (
  request: PreparePaalaegIndberetningRequest,
): Promise<PreparePaalaegIndberetningResponse> =>
  post<PreparePaalaegIndberetningResponse>({
    query: `${PAALAEG_INDBERETNING_QUERY}/prepare-for-signing`,
    body: request,
  });

export const getReportEvidenceByPaalaeg = async (
  paalaegId: string,
): Promise<ReportEvidenceModel[]> => {
  try {
    return await getWithErrorObject<ReportEvidenceModel[]>({
      query: `${PAALAEG_INDBERETNING_QUERY}/paalaeg/${paalaegId}/evidence`,
    });
  } catch (error) {
    if (error instanceof ApiRequestError && error.status === 404) {
      return [];
    }

    throw error;
  }
};
